import { Map, List } from "immutable";
import { STATE_STATUS, STAGE_ACTIONS } from "constants";
import { StageRecord } from "records";

const INITIAL_STATE = new Map({
    data: new List([]),
    status: STATE_STATUS.UNFETCHED
});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case STAGE_ACTIONS.FETCH_STAGES_LIST:
        return state.set("status", STATE_STATUS.FETCHING);
    case STAGE_ACTIONS.FETCHED_STAGES_LIST:
        return state
            .set("status", STATE_STATUS.FETCHED)
            .set(
                "data",
                new List(payload.stageList.map(_ => new StageRecord(_)))
            );
    case STAGE_ACTIONS.FAILED_FETCH_STAGES_LIST:
        return state.set("status", STATE_STATUS.FETCH_FAILED);
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
